/**
 * PrithviMart custom JavaScript
 * Clean version:
 * - Keeps Buy It Now working
 * - Keeps mobile search fix working
 * - Removes old window.scrollTo override that caused mobile freeze
 * - Ends the mobile Add to Cart loading state after successful adds
 */

/* =========================================================
   BUY IT NOW FUNCTIONALITY
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-action="buy-now"]');

    if (!button) return;

    event.preventDefault();

    const productId = button.getAttribute('data-product-id');

    if (!productId) {
      console.error('Product ID not found for Buy it Now button');
      return;
    }

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);

        button.textContent = originalText;
        button.disabled = false;

        alert('Sorry, there was an error adding the product to your cart. Please try again.');
      });
  });

  /* =========================================================
     MOBILE SEARCH DRAWER SUPPORT
     ========================================================= */

  const searchBarWrapper = document.querySelector('.header__search-bar-wrapper');
  const searchInput = document.querySelector('.search-bar__input');

  function closeSearchDrawer() {
    if (!searchBarWrapper) return;

    searchBarWrapper.classList.remove('is-fixed');

    const searchBar = searchBarWrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchInput) {
      searchInput.blur();
    }

    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    const searchResults = searchBarWrapper.querySelector('.search-bar__results');
    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    const searchMenu = searchBarWrapper.querySelector('.search-bar__menu-wrapper');
    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }
  }

  if (searchBarWrapper) {
    let isScrollingInsideDrawer = false;

    const searchInner = searchBarWrapper.querySelector('.search-bar__inner');
    const searchResults = searchBarWrapper.querySelector('.search-bar__results');

    if (searchInner) {
      searchInner.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    if (searchResults) {
      searchResults.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    window.addEventListener(
      'scroll',
      function () {
        if (searchBarWrapper.classList.contains('is-fixed') && !isScrollingInsideDrawer) {
          closeSearchDrawer();
        }
      },
      { passive: true }
    );

    const clearButton = document.querySelector('.search-bar__input-clear');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        setTimeout(function () {
          closeSearchDrawer();
        }, 50);
      });
    }
  }

  /* =========================================================
     CART COUNT UPDATE
     ========================================================= */

  function updateAllCartCounts() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const headerCartCount = document.querySelector('.header__cart-count');
        if (headerCartCount) {
          headerCartCount.textContent = cart.item_count;
        }

        const mobileCartCount = document.getElementById('mobile-cart-count');
        if (mobileCartCount) {
          mobileCartCount.textContent = cart.item_count;
        }

        const allCartCounts = document.querySelectorAll('.cart-count');
        allCartCounts.forEach(function (element) {
          if (element.id !== 'mobile-cart-count') {
            element.textContent = cart.item_count;
          }
        });

        return cart;
      })
      .catch(function (error) {
        console.error('Error updating cart count:', error);
      });
  }

  document.addEventListener('cart:refresh', function () {
    updateAllCartCounts();
  });

  /* =========================================================
     CART PAGE MILESTONE PROGRESS BAR
     ========================================================= */

  function animateProgressBar() {
    const progressFill = document.querySelector('.cart__milestone-progress-fill');

    if (!progressFill) return;

    const inlineWidth = progressFill.getAttribute('style')
      ? progressFill.getAttribute('style').match(/width:\s*([\d.]+)%/)
      : null;

    const targetWidth = progressFill.getAttribute('data-width') || (inlineWidth ? inlineWidth[1] : null);

    if (!targetWidth) return;

    progressFill.style.width = '0%';
    progressFill.style.transition = 'none';

    progressFill.offsetHeight;

    requestAnimationFrame(function () {
      progressFill.style.transition = 'width 1s cubic-bezier(0.4, 0, 0.2, 1)';

      requestAnimationFrame(function () {
        progressFill.style.width = targetWidth + '%';
      });
    });
  }

  if (window.theme && theme.pageType === 'cart') {
    setTimeout(animateProgressBar, 50);
  }
});

/* =========================================================
   PRITHVIMART CLEAN MOBILE SEARCH FIX
   Fixes green bar overlap + unlocks scroll after close
   ========================================================= */

(function () {
  function pmIsMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function pmGetSearchWrapper() {
    return document.querySelector('.header__search-bar-wrapper');
  }

  function pmGetSearchInput() {
    return document.querySelector('.search-bar__input, input[name="q"]');
  }

  function pmHideGreenBar() {
    if (!pmIsMobile()) return;

    document.body.classList.add('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.setProperty('display', 'none', 'important');
      bar.style.setProperty('visibility', 'hidden', 'important');
      bar.style.setProperty('height', '0', 'important');
      bar.style.setProperty('overflow', 'hidden', 'important');
      bar.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function pmShowGreenBar() {
    document.body.classList.remove('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.removeProperty('display');
      bar.style.removeProperty('visibility');
      bar.style.removeProperty('height');
      bar.style.removeProperty('overflow');
      bar.style.removeProperty('pointer-events');
    });
  }

  function pmUnlockScroll() {
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  function pmOpenSearchMode() {
    if (!pmIsMobile()) return;
    pmHideGreenBar();
  }

  function pmCloseSearchMode() {
    const searchWrapper = pmGetSearchWrapper();
    const searchInput = pmGetSearchInput();
    const searchBar = document.querySelector('.search-bar');
    const searchResults = document.querySelector('.search-bar__results');
    const searchMenu = document.querySelector('.search-bar__menu-wrapper');

    if (searchInput) {
      searchInput.blur();
    }

    if (searchWrapper) {
      searchWrapper.classList.remove('is-fixed');
      searchWrapper.classList.add('is-visible');
    }

    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }

    pmUnlockScroll();
    pmShowGreenBar();

    setTimeout(pmUnlockScroll, 100);
    setTimeout(pmUnlockScroll, 300);
    setTimeout(pmShowGreenBar, 300);
  }

  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target.matches('.search-bar__input, input[name="q"]')) {
        setTimeout(pmOpenSearchMode, 50);
        setTimeout(pmOpenSearchMode, 150);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const clickedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const clickedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (clickedClear || clickedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      const touchedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const touchedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (touchedClear || touchedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  const searchWrapper = pmGetSearchWrapper();

  if (searchWrapper) {
    const observer = new MutationObserver(function () {
      if (searchWrapper.classList.contains('is-fixed')) {
        pmOpenSearchMode();
      }
    });

    observer.observe(searchWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  window.addEventListener('pageshow', function () {
    pmUnlockScroll();

    const searchWrapper = pmGetSearchWrapper();
    if (!searchWrapper || !searchWrapper.classList.contains('is-fixed')) {
      pmShowGreenBar();
    }
  });
})();

/* =========================================================
   PRITHVIMART MOBILE ADD TO CART FREEZE FIX
   Releases Add to Cart loading/scroll locks quickly on mobile
   ========================================================= */

(function () {
  let addToCartUnlockTimer = null;

  function pmIsMobileCartFixEnabled() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function pmUnlockMobileCartUi() {
    if (!pmIsMobileCartFixEnabled()) return;

    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  function pmScheduleMobileCartUnlock() {
    if (!pmIsMobileCartFixEnabled()) return;

    clearTimeout(addToCartUnlockTimer);
    addToCartUnlockTimer = setTimeout(pmUnlockMobileCartUi, 1800);
  }

  function pmUpdateCartCounts(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    const countSelectors = [
      '.header__cart-count',
      '#mobile-cart-count',
      '.cart-count',
      '[data-cart-count]',
    ];

    document.querySelectorAll(countSelectors.join(',')).forEach(function (element) {
      element.textContent = cart.item_count;
    });

    const miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      miniCart.setAttribute('data-item-count', cart.item_count);
    }
  }

  function pmAjaxAddToCart(form) {
    const formData = new FormData(form);
    const payload = {};

    formData.forEach(function (value, key) {
      payload[key] = value;
    });

    return fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (content) {
          throw new Error(content.description || content.message || 'Cart add failed');
        });
      }

      return response.json();
    });
  }

  function pmRefreshCartCountOnly() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        pmUpdateCartCounts(cart);
        return cart;
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!pmIsMobileCartFixEnabled()) return;

      const button = event.target.closest('buy-button button[type="submit"], buy-button .button');
      if (!button) return;

    const productItem = button.closest('.product-item');
    const productPageForm = button.closest('.product-form, [data-section-type="product"], [data-section-type="product-quick-view"]');
    if (!productItem && !productPageForm) return;

      const form = button.closest('form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (button.disabled) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding...';

      pmScheduleMobileCartUnlock();

      pmAjaxAddToCart(form)
        .then(function () {
          return pmRefreshCartCountOnly();
        })
        .then(function () {
          button.textContent = 'Added';
          pmUnlockMobileCartUi();

          setTimeout(function () {
            button.disabled = false;
            button.textContent = originalText;
          }, 900);
        })
        .catch(function (error) {
          console.error('Mobile add to cart failed:', error);
          button.disabled = false;
          button.textContent = originalText;
          pmUnlockMobileCartUi();
          alert(error.message || 'Sorry, there was an error adding this product to your cart.');
        });
    },
    true
  );

  function pmEndLoadingAfterAddToCart(event) {
    if (!pmIsMobileCartFixEnabled()) return;
    if (event.detail && event.detail.productAdded === false) return;

    clearTimeout(addToCartUnlockTimer);
    pmUnlockMobileCartUi();
    setTimeout(pmUnlockMobileCartUi, 250);
  }

  document.addEventListener('theme:loading:start', pmScheduleMobileCartUnlock);
  document.addEventListener('product:added', pmEndLoadingAfterAddToCart);
  document.addEventListener('cart:refresh', function () {
    setTimeout(pmUnlockMobileCartUi, 250);
  });
})();

/* =========================================================
   PRITHVIMART COLLECTION TITLE BRAND FILTER
   Builds a helpful brand filter from the first two title words
   ========================================================= */

(function () {
  const filterSelector = '[data-section-type="collection"]';
  const itemSelector = '.product-item[data-pm-title-brand]';
  const filterClass = 'pm-title-brand-filter';
  let rebuildTimer = null;
  let collectionObserver = null;

  function getBrandItems(section) {
    const brands = new Map();

    section.querySelectorAll(itemSelector).forEach(function (item) {
      const brand = (item.getAttribute('data-pm-title-brand') || '').trim();

      if (!brand) return;

      const key = brand.toLowerCase();
      brands.set(key, {
        label: brand,
        count: (brands.get(key) ? brands.get(key).count : 0) + 1,
      });
    });

    return Array.from(brands.values()).sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }

  function createFilter(section, target, suffix) {
    const brands = getBrandItems(section);
    const oldFilter = target.querySelector('.' + filterClass);

    if (oldFilter) {
      oldFilter.remove();
    }

    if (brands.length < 2) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'collection__filter-group ' + filterClass;
    wrapper.innerHTML =
      '<div class="collection__filter-group-name link link--secondary text--strong">' +
      'Brand by title' +
      '</div>' +
      '<ul class="collection__filter-checkbox-list" role="list"></ul>';

    const list = wrapper.querySelector('ul');

    brands.slice(0, 24).forEach(function (brand, index) {
      const id = 'pm-title-brand-' + suffix + '-' + index;
      const li = document.createElement('li');
      const input = document.createElement('input');
      const label = document.createElement('label');

      li.className = 'collection__filter-checkbox';
      input.type = 'checkbox';
      input.id = id;
      input.value = brand.label;
      input.setAttribute('data-pm-title-brand-choice', '');
      label.setAttribute('for', id);
      label.textContent = brand.label + ' (' + brand.count + ')';

      li.appendChild(input);
      li.appendChild(label);
      list.appendChild(li);
    });

    target.appendChild(wrapper);
  }

  function hideNativeBrandFilter(section) {
    section.querySelectorAll('.collection__filter-group-name').forEach(function (heading) {
      if ((heading.textContent || '').trim().toLowerCase() !== 'brand') return;

      const group = heading.closest('.collection__filter-group');

      if (group && !group.classList.contains(filterClass)) {
        group.style.display = 'none';
      }
    });
  }

  function applyTitleBrandFilter(section) {
    const activeBrands = Array.from(section.querySelectorAll('[data-pm-title-brand-choice]:checked')).map(function (input) {
      return input.value.toLowerCase();
    });

    section.querySelectorAll(itemSelector).forEach(function (item) {
      const itemBrand = (item.getAttribute('data-pm-title-brand') || '').toLowerCase();
      const isVisible = activeBrands.length === 0 || activeBrands.indexOf(itemBrand) !== -1;

      item.style.display = isVisible ? '' : 'none';
    });
  }

  function buildTitleBrandFilters() {
    if (collectionObserver) {
      collectionObserver.disconnect();
    }

    document.querySelectorAll(filterSelector).forEach(function (section, sectionIndex) {
      const desktopTarget = section.querySelector('#desktop-filters-form .collection__filter-group-list');
      const mobileTarget = section.querySelector('#mobile-collection-filters-form, #mobile-filters-form');

      hideNativeBrandFilter(section);

      if (desktopTarget) {
        createFilter(section, desktopTarget, 'desktop-' + sectionIndex);
      }

      if (mobileTarget) {
        createFilter(section, mobileTarget, 'mobile-' + sectionIndex);
      }
    });

    observeCollectionChanges();
  }

  function scheduleBuild() {
    clearTimeout(rebuildTimer);
    rebuildTimer = setTimeout(buildTitleBrandFilters, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildTitleBrandFilters);
  } else {
    buildTitleBrandFilters();
  }

  document.addEventListener('shopify:section:load', scheduleBuild);

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-pm-title-brand-choice]')) return;

    const section = event.target.closest(filterSelector);

    if (section) {
      applyTitleBrandFilter(section);
    }
  });

  function observeCollectionChanges() {
    const collectionSection = document.querySelector(filterSelector);

    if (!collectionSection) return;

    collectionObserver = new MutationObserver(scheduleBuild);
    collectionObserver.observe(collectionSection, {
      childList: true,
      subtree: true,
    });
  }
})();
/* PRITHVIMART MOBILE PRODUCT PAGE ADD TO CART FREEZE FIX */
(function () {
  if (window.__pmMobileProductPageAtcFix) return;
  window.__pmMobileProductPageAtcFix = true;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function unlockMobileUi() {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.documentElement.classList.remove('is-locked', 'no-mobile-scroll');
    document.body.classList.remove('is-locked', 'no-mobile-scroll');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  function updateCartCounts(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-item-count, .cart__count').forEach(function (count) {
      count.textContent = cart.item_count;
      count.classList.toggle('hidden', cart.item_count === 0);
    });
  }

  document.addEventListener('click', function (event) {
    if (!isMobile()) return;

    const button = event.target.closest('buy-button button[type="submit"], buy-button .button');
    if (!button || button.closest('.product-item') || button.closest('.shopify-payment-button')) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    unlockMobileUi();

    const unlockTimer = setTimeout(unlockMobileUi, 1800);

    fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().then(function (error) {
          throw new Error(error.description || error.message || 'Unable to add to cart');
        });
      })
      .then(function () {
        clearTimeout(unlockTimer);
        button.textContent = 'Added';
        unlockMobileUi();

        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(updateCartCounts)
          .catch(function () {});

        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 900);
      })
      .catch(function (error) {
        clearTimeout(unlockTimer);
        console.error('Mobile product add to cart failed:', error);
        button.disabled = false;
        button.textContent = originalText;
        unlockMobileUi();
        alert(error.message || 'Sorry, there was an error adding this product to your cart.');
      });
  }, true);
})();
/* PRITHVIMART MOBILE PRODUCT ADD TO CART POST-ADD UNLOCK */
(function () {
  if (window.__pmMobileProductAtcPostUnlock) return;
  window.__pmMobileProductAtcPostUnlock = true;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function forceUnlock() {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.body.dispatchEvent(new CustomEvent('theme:loading:end'));

    document.documentElement.classList.remove('is-locked', 'no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');
    document.body.classList.remove('is-locked', 'no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');

    ['overflow', 'overflowY', 'height', 'position', 'top', 'width', 'touchAction', 'pointerEvents'].forEach(function (prop) {
      document.documentElement.style[prop] = '';
      document.body.style[prop] = '';
    });

    document.querySelectorAll('[aria-busy="true"]').forEach(function (element) {
      element.removeAttribute('aria-busy');
    });
  }

  document.addEventListener('click', function (event) {
    if (!isMobile()) return;

    const button = event.target.closest('buy-button button[type="submit"], buy-button .button');
    if (!button || button.closest('.product-item') || button.closest('.shopify-payment-button')) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    setTimeout(forceUnlock, 350);
    setTimeout(forceUnlock, 1000);
    setTimeout(forceUnlock, 2200);
  }, true);

  document.addEventListener('product:added', function () {
    if (!isMobile()) return;
    setTimeout(forceUnlock, 50);
    setTimeout(forceUnlock, 700);
  });
})();
/* PRITHVIMART GLOBAL MOBILE ADD TO CART FAST PATH */
(function () {
  if (window.__pmGlobalMobileAtcFastPath) return;
  window.__pmGlobalMobileAtcFastPath = true;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function unlockUi() {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end'));
    document.body.dispatchEvent(new CustomEvent('theme:loading:end'));

    document.documentElement.classList.remove('is-locked', 'no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');
    document.body.classList.remove('is-locked', 'no-mobile-scroll', 'lock-all', 'lock-mobile', 'overflow-hidden');

    ['overflow', 'overflowY', 'height', 'position', 'top', 'width', 'touchAction', 'pointerEvents'].forEach(function (prop) {
      document.documentElement.style[prop] = '';
      document.body.style[prop] = '';
    });
  }

  function updateCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, .cart-item-count, .cart__count').forEach(function (count) {
      count.textContent = cart.item_count;
      count.classList.toggle('hidden', cart.item_count === 0);
    });
  }

  document.addEventListener('click', function (event) {
    if (!isMobile()) return;

    const button = event.target.closest('buy-button button[type="submit"], buy-button .button');
    if (!button || button.closest('.shopify-payment-button')) return;

    const form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    unlockUi();

    const unlockTimers = [120, 450, 1000, 2200].map(function (delay) {
      return setTimeout(unlockUi, delay);
    });

    fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.json().then(function (error) {
          throw new Error(error.description || error.message || 'Unable to add to cart');
        });
      })
      .then(function () {
        unlockTimers.forEach(clearTimeout);
        unlockUi();
        button.textContent = 'Added';

        fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (response) {
            return response.ok ? response.json() : null;
          })
          .then(updateCartCount)
          .catch(function () {});

        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
          unlockUi();
        }, 700);
      })
      .catch(function (error) {
        unlockTimers.forEach(clearTimeout);
        console.error('Mobile add to cart failed:', error);
        button.disabled = false;
        button.textContent = originalText;
        unlockUi();
        alert(error.message || 'Sorry, there was an error adding this product to your cart.');
      });
  }, true);
})();
